
import {BsPhoneFill} from "react-icons/bs"
import {FaUser} from "react-icons/fa"
import {MdEmail} from "react-icons/md"
export const PersonalInfo = (props:any) => {
  return (
    <div className="outer-container">
    <div className="inner-container">
      <div className="info-container">
        <span className="toolicon"><FaUser /></span>
        <span className="tooltext">{props.name}</span>
      </div>
    </div>
    <div className="inner-container">
      <div className="info-container">
        <span className="toolicon"><MdEmail /></span>
        <span className="tooltext">{props.email}</span>
      </div>
    </div>
    <div className="inner-container">
      <div className="info-container">
        <span className="toolicon"><BsPhoneFill /></span>
        <span className="tooltext">{props.phone}</span>
      </div>
    </div>
  </div>
  )
}
